<template>
  <div class="row">
    <div class="col-md-12 card">
      <div class="card-header">
        <h4 class="title">Scanner</h4>
      </div>
      <div class="card-content row">
        <qrcode-reader @decode="onDecode" @locate="onLocate"></qrcode-reader>
      </div>
    </div>
  </div>
</template>
<script>
  import { QrcodeReader } from 'vue-qrcode-reader'

  export default{
    components: {
      QrcodeReader
    },
    methods: {
      onDecode (content) {
        console.log('on decode: ' + content)
        window.location = content
      },
      onLocate (points) {
        console.log('on locate: ' + points)
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Dashboard/Scan.vue